import script from "./AppSocialMediaLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSocialMediaLinks.vue?vue&type=script&setup=true&lang=js"

import "./AppSocialMediaLinks.vue?vue&type=style&index=0&id=f6dc9ad6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6dc9ad6"]])

export default __exports__